module.exports = __webpack_public_path__ + "static/media/header_id_name78f48fc1ab0f2a3c44a471a26d235756.webp";